import script from "./VensoInvoiceRequestView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoInvoiceRequestView.vue?vue&type=script&setup=true&lang=ts"

import "./VensoInvoiceRequestView.vue?vue&type=style&index=0&id=07fc0045&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07fc0045"]])

export default __exports__